import CryptoJS from "crypto-js";
import axios from "axios";
import { toast } from "react-toastify";

const baseDomain = process.env.REACT_APP_BASE_URL;
export const baseURL = `${baseDomain}`;

const instance = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache",
  },
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const isLoginRequest = error.config?.url?.includes("admin-auth/login");
      const logoutKey = error.response.data?.logout;
      const unAuth = error.response.status;
      const msg = (error?.response?.data?.message || "").toLowerCase();
      const isAccountDisabled =
        msg.includes("inactive") ||
        msg.includes("disabled") ||
        msg.includes("deactivated") ||
        msg.includes("not active") ||
        msg.includes("account has been disabled") ||
        msg.includes("account is inactive");

      if (!isLoginRequest && (logoutKey || unAuth === 401 || (unAuth === 403 && isAccountDisabled))) {
        if (!toast.isActive("session-expired-toast")) {
          toast.error(error?.response?.data?.message || "Session expired. Please log in again.", {
            toastId: "session-expired-toast",
          });
        }
        setTimeout(() => {
          localStorage.clear();
          localStorage.removeItem("auth");
          window.location.href = "/auth/login";
        }, 1500);
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

instance.interceptors.request.use((config) => {
  const serializedUid = localStorage.getItem("auth");
  if (serializedUid !== null) {
    let auth = JSON.parse(
      CryptoJS.AES.decrypt(serializedUid, "my-secret-key").toString(
        CryptoJS.enc.Utf8
      )
    );

    config.headers.Authorization = `Bearer ${auth.authToken}`;
  }
  return config;
});

export default instance;
